import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
import { FaExternalLinkAlt } from "react-icons/fa";

const CHANNELS = [
  {
    name: "Instagram",
    handle: "@prefeituradeserrinha",
    description:
      "Fotos, vídeos e atualizações do dia a dia da administração municipal.",
    href: "https://www.instagram.com",
    icon: <FaInstagram />,
    iconBg: "bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400",
    hoverBorder: "hover:border-pink-300",
  },
  {
    name: "Facebook",
    handle: "Prefeitura de Serrinha",
    description:
      "Notícias, eventos e comunicados oficiais da Prefeitura de Serrinha.",
    href: "https://www.facebook.com",
    icon: <FaFacebook />,
    iconBg: "bg-blue-600",
    hoverBorder: "hover:border-blue-300",
  },
  {
    name: "YouTube",
    handle: "Prefeitura de Serrinha",
    description:
      "Transmissões ao vivo, sessões e vídeos institucionais da gestão municipal.",
    href: "https://www.youtube.com",
    icon: <FaYoutube />,
    iconBg: "bg-red-600",
    hoverBorder: "hover:border-red-300",
  },
];

const SocialMedia = () => (
  <div className="p-6 md:p-8 space-y-8 max-w-3xl mx-auto">

    {/* Intro */}
    <div className="bg-blue-50 border border-blue-100 rounded-xl p-5">
      <p className="text-blue-900 text-sm leading-relaxed">
        Acompanhe a Prefeitura de Serrinha nas redes sociais para ficar por dentro
        de notícias, eventos, obras e ações da gestão municipal em tempo real.
        Clique em qualquer canal abaixo para acessar nossa página oficial.
      </p>
    </div>

    {/* Channel cards */}
    <div className="space-y-4">
      {CHANNELS.map(({ name, handle, description, href, icon, iconBg, hoverBorder }) => (
        <a
          key={name}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={`flex items-center gap-5 p-5 bg-white border border-gray-200 rounded-xl shadow-sm transition group ${hoverBorder} hover:shadow-md`}
        >
          <div className={`flex items-center justify-center w-14 h-14 rounded-xl text-white text-2xl shrink-0 ${iconBg}`}>
            {icon}
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-bold text-gray-800 text-base">{name}</p>
            <p className="text-sm text-gray-400 mb-1">{handle}</p>
            <p className="text-sm text-gray-600 leading-snug">{description}</p>
          </div>
          <FaExternalLinkAlt className="text-gray-300 group-hover:text-gray-500 transition shrink-0" />
        </a>
      ))}
    </div>

  </div>
);

export default SocialMedia;
